import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { CommuneState } from './commune.state';
import {
  BarChartConfiguration,
  LineConfiguration,
  MapConfiguration,
  PieConfiguration,
  PolarConfiguration,
  RadarConfiguration,
  ScatterConfiguration,
  TableConfiguration,
} from '../../models/commune';
import { defaultSorting } from '../../services/grid-widget-config.service';

export function withWidgetConfig() {
  return signalStoreFeature(
    {
      state: type<CommuneState>(),
    },
    withComputed(() => ({
      baseMapConfig: computed((): MapConfiguration => {
        return {
          tileLayer: 'Graustufen',
          captions: {
            key: false,
            name: true,
            value: false,
            chart: false,
            style: 'top',
          },
          colorset: undefined,
          showChart: false,
          hideKaValues: true,
          direction: 'center',
          legendScope: 'group',
          legend: {
            legendScope: 'group',
            scaleMode: 'width',
            size: 'large',
            position: 'bottomright',
            numberOfScales: 6,
            invert: false,
          },
          districtOpacity: 1,
          strokeColor: '#444444',
          poiSize: 0.5,
          emptyFillColor: '#cccccc',
        };
      }),
      baseBarChartConfig: computed((): BarChartConfiguration => {
        return {
          displayValues: false,
          sort: defaultSorting,
          caption: 'name',
          colorset: '',
          mode: 'vertical',
          stacked: false,
        };
      }),
      baseLineConfig: computed((): LineConfiguration => {
        return {
          strokeWidth: 1,
          lineTension: 0,
          dotSize: 3,
          colorset: undefined,
        };
      }),
      baseScatterConfig: computed((): ScatterConfiguration => {
        return {
          displayRegression: false,
          dotSize: 3,
        };
      }),
      basePieConfig: computed((): PieConfiguration => {
        return {
          colorset: '',
          displayValues: false,
          innerRadius: 0,
          sort: defaultSorting,
          name: '',
        };
      }),
      baseTableConfig: computed((): TableConfiguration => {
        return {
          displayKeys: false,
          captionTotal: 'Gesamt',
          captionAverage: 'AVG',
          captionDistrict: 'Region',
          captionKey: 'key',
          transpose: false,
          sort: defaultSorting,
        };
      }),
      basePolarConfig: computed((): PolarConfiguration => {
        return {
          colorset: undefined,
          displayValues: false,
          //sort: defaultSorting,
        };
      }),
      baseRadarConfig: computed((): RadarConfiguration => {
        return {
          colorset: undefined,
          displayValues: false,
          dotSize: 0,
          featureOpacity: 0.5,
          lineTension: 0.5,
        };
      }),
    }))
  );
}
